import api from 'api';
import {useGetApi} from 'common/hooks/useGetApi';
import React from 'react';
import {useDispatch} from 'react-redux';
import {action} from 'redux/helpers';
import {ILicense} from 'types/License';
import {licenseTypes} from '..';

export const useActivateLicense = () => {
   const dispatch = useDispatch();

   const [newLicenseActivated, setNewLicenseActivated] = React.useState(false);

   const {request, loading: licenseIsLoading} = useGetApi<ILicense>(
      `${api.license}?operation=updateLicense`,
      {
         onSuccess: (data) => {
            dispatch(action(licenseTypes.GET_LICENSE.SUCCESS, data));
            // dispatch(action(licenseTypes.GET_LICENSE.SAGA));
            setNewLicenseActivated(true);
         },
      }
   );

   const activateNewLicense = React.useCallback(() => request(), [request]);

   return {activateNewLicense, newLicenseActivated, licenseIsLoading};
};
